import React, { useContext } from 'react'

import { DefaultLayoutComponent } from './layout'

import { OrgUnitAnalytics as OrgUnitAnalyticsComponent } from '../components/OrgUnitAnalytics'
import { OrgUnitProvider } from './dataProviders'
import { BackdropLoader, Box } from '@percept/mui'
import { useDocumentTitle } from '@percept/hooks'
import { OrgUnitContext } from '@percept/app-components'


const OrgUnitAnalyticsView = (): JSX.Element => {
  const orgUnit = useContext(OrgUnitContext)
  useDocumentTitle({
    paths: [
      orgUnit.name,
      'Analytics',
    ]
  })
  return (
    <Box my={3} px={3}>
      <OrgUnitAnalyticsComponent />
    </Box>
  )
}

export const OrgUnitAnalyticsScreen = (): JSX.Element => {
  return (
    <DefaultLayoutComponent>
      <OrgUnitProvider
        fallback={<BackdropLoader />}>
        <OrgUnitAnalyticsView />
      </OrgUnitProvider>
    </DefaultLayoutComponent>
  )
}

export default OrgUnitAnalyticsScreen
